import { useEffect, useRef } from "react";

// Tally-style Esc: screens push a step-back handler; global Esc pops ONE
// internal step at a time (detail → list → previous route), never jumping
// all the way back.
export const escStack = [];

export function useEscStep(handler) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    const fn = () => (ref.current ? ref.current() : false);
    escStack.push(fn);
    return () => { const i = escStack.indexOf(fn); if (i >= 0) escStack.splice(i, 1); };
  }, []);
}

export function runEscStep() {
  for (let i = escStack.length - 1; i >= 0; i--) {
    try { if (escStack[i]()) return true; } catch { /* noop */ }
  }
  return false;
}
